import {AxiosResponse} from 'axios';
//api
import {userAPI} from '@/core/api';
//types
import {IBuyRaffleResponse, IRaffleRequest} from '@/utils/types';
//enum
import {API_URL} from '../enums/api-url.enum';

class RaffleService {
	static buy = async ({
		eventId,
		reqBody,
	}: {
		eventId: number;
		reqBody: IRaffleRequest;
	}): Promise<AxiosResponse<IBuyRaffleResponse>> =>
		userAPI.post(`${API_URL.EVENT}/${eventId}/raffle/purchase`, reqBody);
}

export {RaffleService};
